import "./ProblemSection.css";

const ProblemSection = () => {
  return (
    <section className="problem-section">
      <div className="problem-section__header">
        <span className="problem-section__eyebrow">
          <span className="problem-section__dot"></span>
          The Real Problem
        </span>

        <h2>Campaigns should not run on guesswork.</h2>

        <p>
          Influencer campaigns are too complex for email threads and
          spreadsheets. Xyncely brings everything into one place.
        </p>
      </div>

      <div className="problem-section__cards">
        <div className="problem-card">
          <span className="problem-card__icon">×</span>
          <h3>Briefs lost in inboxes</h3>
          <p>No single source of truth.</p>
        </div>

        <div className="problem-card">
          <span className="problem-card__icon">×</span>
          <h3>Approvals stuck in WhatsApp</h3>
          <p>Zero audit trail.</p>
        </div>

        <div className="problem-card">
          <span className="problem-card__icon">×</span>
          <h3>Reporting assembled manually</h3>
          <p>Hours spent compiling screenshots.</p>
        </div>

        <div className="problem-card">
          <span className="problem-card__icon">×</span>
          <h3>Payments tracked in spreadsheets</h3>
          <p>Commercial terms scattered.</p>
        </div>
      </div>

      <div className="problem-section__stats">
        <div className="problem-stat">
          <strong>01</strong>
          <h3>One source of truth</h3>
          <p>Every brief, deliverable, and approval in one place</p>
        </div>

        <div className="problem-stat">
          <strong>04</strong>
          <h3>Execution layers</h3>
          <p>Plan → Create → Approve → Prove → Pay</p>
        </div>

        <div className="problem-stat">
          <strong>360°</strong>
          <h3>Campaign visibility</h3>
          <p>Full view across brands, vendors, and creators</p>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;